/* globals document, window */
import React, { Fragment } from "react";
import GlobalAlert from "../common/GlobalAlert";
import LoginForm from "./LoginForm";

import { GlobalProvider } from "../common/GlobalContext";

type Props = {
  alerts: Array<Object>,
  className: string,
  compliance: Object,
  favorites: Array<number>,
  RECAPTCHA_CLIENT: string,
  RECAPTCHA_CLIENT_V2: string,
  siteUser: Object,
  tenant: string,
  theme: Object, // theme from the API/site settings, not the react-jss theme
};

const Login = ({
  alerts,
  compliance,
  favorites,
  RECAPTCHA_CLIENT,
  RECAPTCHA_CLIENT_V2,
  siteUser,
  tenant,
  theme,
  location,
}: Props) => {
  return (
    <GlobalProvider
      compliance={compliance}
      favorites={favorites}
      siteUser={siteUser}
      theme={theme}
      RECAPTCHA_CLIENT={RECAPTCHA_CLIENT}
      RECAPTCHA_CLIENT_V2={RECAPTCHA_CLIENT_V2}
    >
      <Fragment>
        <div style={{ maxWidth: "400px", margin: "20px auto 0px" }}>
          <GlobalAlert alerts={alerts} />
        </div>
        <LoginForm tenant={tenant} location={location} />
      </Fragment>
    </GlobalProvider>
  );
};

export default Login;
